/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { Prisma, UserSessionLog } from ".zenstack/models";
import type { UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { getHooksContext } from '@zenstackhq/tanstack-query/runtime-v5/react';
import { useModelQuery, useInfiniteModelQuery, useModelMutation } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { PickEnumerable, CheckSelect, QueryError, ExtraQueryOptions, ExtraMutationOptions } from '@zenstackhq/tanstack-query/runtime-v5';
import type { PolicyCrudKind } from '@zenstackhq/runtime'
import metadata from './__model_meta';
type DefaultError = QueryError;
import { useSuspenseModelQuery, useSuspenseInfiniteModelQuery } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { UseSuspenseQueryOptions, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';

export function useCreateUserSessionLog(options?: Omit<(UseMutationOptions<(UserSessionLog | undefined), DefaultError, Prisma.UserSessionLogCreateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.UserSessionLogCreateArgs, DefaultError, UserSessionLog, true>('UserSessionLog', 'POST', `${endpoint}/userSessionLog/create`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.UserSessionLogCreateArgs>(
            args: Prisma.SelectSubset<T, Prisma.UserSessionLogCreateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, UserSessionLog, Prisma.UserSessionLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.UserSessionLogCreateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, UserSessionLog, Prisma.UserSessionLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useCreateManyUserSessionLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.UserSessionLogCreateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.UserSessionLogCreateManyArgs, DefaultError, Prisma.BatchPayload, false>('UserSessionLog', 'POST', `${endpoint}/userSessionLog/createMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.UserSessionLogCreateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.UserSessionLogCreateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.UserSessionLogCreateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useFindManyUserSessionLog<TArgs extends Prisma.UserSessionLogFindManyArgs, TQueryFnData = Array<Prisma.UserSessionLogGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogFindManyArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/findMany`, args, options, fetch);
}

export function useInfiniteFindManyUserSessionLog<TArgs extends Prisma.UserSessionLogFindManyArgs, TQueryFnData = Array<Prisma.UserSessionLogGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogFindManyArgs>, options?: Omit<UseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useInfiniteModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/findMany`, args, options, fetch);
}

export function useSuspenseFindManyUserSessionLog<TArgs extends Prisma.UserSessionLogFindManyArgs, TQueryFnData = Array<Prisma.UserSessionLogGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogFindManyArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/findMany`, args, options, fetch);
}

export function useSuspenseInfiniteFindManyUserSessionLog<TArgs extends Prisma.UserSessionLogFindManyArgs, TQueryFnData = Array<Prisma.UserSessionLogGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogFindManyArgs>, options?: Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseInfiniteModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/findMany`, args, options, fetch);
}

export function useFindUniqueUserSessionLog<TArgs extends Prisma.UserSessionLogFindUniqueArgs, TQueryFnData = Prisma.UserSessionLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogFindUniqueArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/findUnique`, args, options, fetch);
}

export function useSuspenseFindUniqueUserSessionLog<TArgs extends Prisma.UserSessionLogFindUniqueArgs, TQueryFnData = Prisma.UserSessionLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogFindUniqueArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/findUnique`, args, options, fetch);
}

export function useFindFirstUserSessionLog<TArgs extends Prisma.UserSessionLogFindFirstArgs, TQueryFnData = Prisma.UserSessionLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogFindFirstArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/findFirst`, args, options, fetch);
}

export function useSuspenseFindFirstUserSessionLog<TArgs extends Prisma.UserSessionLogFindFirstArgs, TQueryFnData = Prisma.UserSessionLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogFindFirstArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/findFirst`, args, options, fetch);
}

export function useUpdateUserSessionLog(options?: Omit<(UseMutationOptions<(UserSessionLog | undefined), DefaultError, Prisma.UserSessionLogUpdateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.UserSessionLogUpdateArgs, DefaultError, UserSessionLog, true>('UserSessionLog', 'PUT', `${endpoint}/userSessionLog/update`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.UserSessionLogUpdateArgs>(
            args: Prisma.SelectSubset<T, Prisma.UserSessionLogUpdateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, UserSessionLog, Prisma.UserSessionLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.UserSessionLogUpdateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, UserSessionLog, Prisma.UserSessionLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useUpdateManyUserSessionLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.UserSessionLogUpdateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.UserSessionLogUpdateManyArgs, DefaultError, Prisma.BatchPayload, false>('UserSessionLog', 'PUT', `${endpoint}/userSessionLog/updateMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.UserSessionLogUpdateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.UserSessionLogUpdateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.UserSessionLogUpdateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useUpsertUserSessionLog(options?: Omit<(UseMutationOptions<(UserSessionLog | undefined), DefaultError, Prisma.UserSessionLogUpsertArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.UserSessionLogUpsertArgs, DefaultError, UserSessionLog, true>('UserSessionLog', 'POST', `${endpoint}/userSessionLog/upsert`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.UserSessionLogUpsertArgs>(
            args: Prisma.SelectSubset<T, Prisma.UserSessionLogUpsertArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, UserSessionLog, Prisma.UserSessionLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.UserSessionLogUpsertArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, UserSessionLog, Prisma.UserSessionLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteUserSessionLog(options?: Omit<(UseMutationOptions<(UserSessionLog | undefined), DefaultError, Prisma.UserSessionLogDeleteArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.UserSessionLogDeleteArgs, DefaultError, UserSessionLog, true>('UserSessionLog', 'DELETE', `${endpoint}/userSessionLog/delete`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.UserSessionLogDeleteArgs>(
            args: Prisma.SelectSubset<T, Prisma.UserSessionLogDeleteArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, UserSessionLog, Prisma.UserSessionLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.UserSessionLogDeleteArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, UserSessionLog, Prisma.UserSessionLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteManyUserSessionLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.UserSessionLogDeleteManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.UserSessionLogDeleteManyArgs, DefaultError, Prisma.BatchPayload, false>('UserSessionLog', 'DELETE', `${endpoint}/userSessionLog/deleteMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.UserSessionLogDeleteManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.UserSessionLogDeleteManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.UserSessionLogDeleteManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useAggregateUserSessionLog<TArgs extends Prisma.UserSessionLogAggregateArgs, TQueryFnData = Prisma.GetUserSessionLogAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogAggregateArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/aggregate`, args, options, fetch);
}

export function useSuspenseAggregateUserSessionLog<TArgs extends Prisma.UserSessionLogAggregateArgs, TQueryFnData = Prisma.GetUserSessionLogAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogAggregateArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/aggregate`, args, options, fetch);
}

export function useGroupByUserSessionLog<TArgs extends Prisma.UserSessionLogGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.UserSessionLogGroupByArgs['orderBy'] } : { orderBy?: Prisma.UserSessionLogGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.UserSessionLogGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.UserSessionLogGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.UserSessionLogGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.UserSessionLogGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.UserSessionLogGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/groupBy`, args, options, fetch);
}

export function useSuspenseGroupByUserSessionLog<TArgs extends Prisma.UserSessionLogGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.UserSessionLogGroupByArgs['orderBy'] } : { orderBy?: Prisma.UserSessionLogGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.UserSessionLogGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.UserSessionLogGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.UserSessionLogGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.UserSessionLogGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.UserSessionLogGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/groupBy`, args, options, fetch);
}

export function useCountUserSessionLog<TArgs extends Prisma.UserSessionLogCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.UserSessionLogCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogCountArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/count`, args, options, fetch);
}

export function useSuspenseCountUserSessionLog<TArgs extends Prisma.UserSessionLogCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.UserSessionLogCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.UserSessionLogCountArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('UserSessionLog', `${endpoint}/userSessionLog/count`, args, options, fetch);
}

export function useCheckUserSessionLog<TError = DefaultError>(args: { operation: PolicyCrudKind; where?: { createdById?: string; updatedById?: string; deletedById?: string; id?: string; userId?: string; userAgent?: string; ipAddress?: string }; }, options?: (Omit<UseQueryOptions<boolean, TError, boolean>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<boolean, boolean, TError>('UserSessionLog', `${endpoint}/userSessionLog/check`, args, options, fetch);
}
